import { DynamicPageComponent } from './dynamic-page/dynamic-page.component';

export const DYNAMIC_PAGE_COMPONENTS = [DynamicPageComponent];

export * from './dynamic-page/dynamic-page.component';
